<template>
  <div class="cusSerCenter">
    <breadcrumb :link-list="breadcrumbList"></breadcrumb>
    <div class="header">
      <div class="headTitle">
        <img class="headIcon" src="@/assets/image/AccountDeal/gameSelectHead/cusSerIcon.png">
        <div class="headText">客服列表</div>
      </div>
      <div class="headBack" @click="backBtn">返回</div>
    </div>
    <!--  客服列表 cusSerList -->
    <div class="cusSerList">
      <div class="head">
        <img :src="selectGame.game_image" alt="">
        {{ selectGame.game_name }}&ensp;-&ensp;客服列表
      </div>
      <div class="list" v-if="[2,3].includes(selectGame.sys_service_type)" style="padding:0;">
        <a :class="item.session_info && item.session_info.status === 0 ?'':'afterWork'" class="cusSer QQSGcusSer" v-for="(item,index) in cursList"
            :key="index" @click="customClicks(item)" target="_blank">
          <div class="cus-head">
            <img src="@/assets/image/Home/cusSerCenterIcon.png">
          </div>
          <div class="name">{{ item.nickname }}</div>
          <div class="division"></div>
          <a class="btn" v-if="item.session_info && item.session_info.status === 0" @click.stop="customClicks(item)" target="_blank">咨询客服</a>
          <a class="btn" v-else target="_blank">客服不在线</a>
        </a>
      </div>
      <div class="list" v-else>
        <a :class="item.is_work === 0 ?'afterWork':''" class="cusSer" v-for="(item,index) in selectGame.buy_list"
            :key="index" @click="customClick(item)" target="_blank">
          <div class="info">
            <div class="name">{{ item.work_name }}</div>
            <div class="qr_code">
              <img :src="item.qr_code_url" alt="">
            </div>
            <div class="tip">
              <img src="@/assets/image/CusSerCenter/scanCode.png" alt="">
              微信扫码
            </div>
          </div>
          <a class="btn" v-if="item.is_work === 0" target="_blank">客服不在线</a>
          <a class="btn" @click.stop="customClick(item)" v-else target="_blank">咨询客服</a>
        </a>
      </div>
    </div>
    <wxChatGlobal :visible.sync="merVisible" :describe="customer_describe" :qr_code_url="qr_code_url"></wxChatGlobal>
  </div>
</template>
<script>
import {openIM} from '@/util/openIM'
import {apiRecyclingList, apiGameInfo,apiGetCustomerQrcodeList} from "@/request/API";
import breadcrumb from "@/components/breadcrumb";
import chatApi from '@/request/customer/customerRoom'
import {Decrypt} from '@/request/customer/util.js'
import wxChatGlobal from '../../chat/components/wxChatGlobal.vue';
import { getServiceListApi } from "@/request/im";

export default {
  name: 'cusSerCenter',
  props: {},
  components: {
    breadcrumb,
    wxChatGlobal
  },
  data() {
    return {
      // 面包屑
      breadcrumbList: [
        {link: 'CusSerCenter', name: '客服中心'},
        {name: '客服列表'},
      ],
      // 选择的游戏
      selectGame: '',
      cursList: [],
      game_id: '',
      customer_qr_code_flag: '',
      merVisible: false,
      customer_describe: '',
      qr_code_url: ''
    }
  },
  created() {
    // this.cueGrouplist()
    this.game_id = this.$route.query?.game_id
    if (this.game_id) {
      this.step = 2
      let query = {}
      if (this.game_id == 7) {
        query.match = '无板块游戏'
      } else {
        query.game_id = this.game_id
      }
      apiGameInfo({
        id:query.game_id
      }).then(res => {
        this.selectGame = res.data
        apiGetCustomerQrcodeList({
          game_id: this.game_id
        }).then(res => {
          this.customer_qr_code_flag = res.data.customer_qr_code_flag
          if(res.data.customer_qr_code_flag == 1){
            let list = res.data.list
            list.forEach(item => {
              item.isonline = item.is_work
              item.nickname = item.name
            })
            this.cursList = list
          }else{
            this.getcustomercarelist()
          }
        })
      })
    }
  },
  methods: {
    customClicks(item) {
      if (item.session_info.status == 0) {
        const qrInfo = JSON.parse(item.qrcode)
        // todo 暂时不考虑二维码展示，待后端添加
        if(this.customer_qr_code_flag == 19999){
          this.qr_code_url = item.qr_code_url
          this.customer_describe = item.customer_describe
          this.merVisible = true
        }else{
          this.$openIM({
            serviceName: item.name,
            serviceId: item.user_id
          })
        }
      } else {
        this.$message({
          center: true,
          type: 'error',
          message: "当前客服不在线"
        })
      }
    },
    /**
     * @description: 获取客服分组列表
     * @return {*}
     */
    cueGrouplist() {
      chatApi.grouplist({
        msg: chatApi.encryptMsg({
          format: 'json',
          type: 3
        })
      }).then(res => {
        // console.log('客服分组列表',JSON.parse(Decrypt(res.result)));
      }).catch(err => {
      })
    },
    /**
     * @description: 客服随机排序
     * @param {*} array
     * @return {*}
     */
    randomSort(array) {
      let length = array.length;
      if (!Array.isArray(array) || length <= 1) return;
      for (let index = 0; index < length - 1; index++) {
        let randomIndex = Math.floor(Math.random() * (length - index)) + index;
        [array[index], array[randomIndex]] = [array[randomIndex], array[index]];
      }
      return array;
    },
    /**
     * @description: 根据分组标识获取客服列表
     * @return {*}
     */
    getcustomercarelist() {
      getServiceListApi({
        game_code: this.selectGame.game_alias
      }).then(res => {
        let data = res.data
        let online = [],office = []
        data.forEach(item => {
          if(item?.session_info?.status == 0){
            online.push(item)
          }else{
            office.push(item)
          }
        });
        let list = []
        // if(online.length>1){
        //   list = this.randomSort(online)
        // } else {
        //   list = online
        // }
        this.cursList = [...online,...office]
      }).catch(err => {
      })
    },
    customClick(item) {
      if (item.is_work === 0) {
        this.$message({
          center: true,
          type: 'error',
          message: "当前客服不在线"
        })
      } else {
        this.$accessLink(item.work_id)
        window.open(`${item.work_id}?u_cust_id=${this.$store.state.userData.user_id}&u_cust_name=${this.$store.state.userData.nickname}`, '_blank')
      }
    },
    /**
     * 返回
     */
    backBtn() {
      this.$router.go(-1)
    }

  },
  mounted() {
    if (this.$store.state.loginStatus) {
      sby_setuserid(this.$store.state.userData.telphone, this.$store.state.userData.nickname, this.$store.state.userData.avatar == '' ? 'https://m.pxb7.com/image/public/avatar.jpg' : this.$store.state.userData.avatar)
    } else {
      this.$message({
        type: "error",
        message: '尚未登录，请先登录。',
        center: true
      })
      this.$router.push({
        path: '/login',
        query: {
          Rurl: this.$route.path,
        },
      })
    }
  },
}
</script>

<style lang='less' scoped>
.cusSerCenter {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 1200px;
  margin: 0 auto 32px;

  .header {
    width: 1200px;
    height: 100px;
    background: var(--bg-dark, #1A1D24);
    border-radius: 4px 4px 0 0;
    padding: 0 44px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    box-sizing: border-box;

    .headTitle {
      display: flex;
      flex-direction: row;
      align-items: center;

      .headIcon {
        width: 42px;
        height: 42px;
        object-fit: contain;
      }

      .headText {
        font-size: 24px;
        font-family: PingFang SC, PingFang SC-Semibold;
        font-weight: 600;
        text-align: CENTER;
        color: #FFFFFF;
        margin: 0 24px 0 10px;
      }

    }

    .headBack {
      height: 36px;
      line-height: 34px;
      padding: 0 16px;
      border: 1px solid rgba(255, 255, 255, 0.55);
      border-radius: 4px;
      background: rgba(255, 255, 255, 0.12);
      font-size: 15px;
      font-family: PingFang SC, PingFang SC-Semibold;
      font-weight: 500;
      color: #FFFFFF;
      cursor: pointer;
      box-sizing: border-box;
      transition: color 0.2s ease, background 0.2s ease, border-color 0.2s ease;

      &:hover {
        background: rgba(255, 255, 255, 0.2);
        border-color: rgba(255, 255, 255, 0.8);
      }
    }
  }


  .cusSerList {
    width: calc(1200px - 50px);
    background: var(--bg-card, #FFFFFF);
    padding: 0 25px 100px;

    .head {
      display: flex;
      flex-direction: row;
      align-items: center;
      padding: 40px 18px;
      font-size: 24px;
      font-family: PingFang SC, PingFang SC-Regular;
      font-weight: 400;
      color: var(--text-main, #111827);
      border-bottom: 1px solid var(--border-soft, #E8E4DE);

      img {
        width: 80px;
        height: 80px;
        border-radius: 4px;
        margin: 0 25px 0 0;
        object-fit: cover;
        box-shadow: 0 6px 14px rgba(15, 23, 42, 0.08);
      }
    }

    .cus_main {
      display: flex;
      justify-content: flex-start;
    }

    .list {
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
      padding: 0 6px;
      margin: 20px 0 0;

      .cusSer {
        width: 168px;
        background: var(--bg-section, #F7F5F2);
        border: 1px solid var(--border-soft, #E8E4DE);
        border-radius: 4px;
        margin: 20px 9px 0;
        cursor: pointer;
        box-shadow: 0 6px 16px rgba(26, 29, 36, 0.04);
        transition: border-color 0.2s ease, box-shadow 0.2s ease, transform 0.2s ease;

        .info {
          padding: 15px 0 0;
          display: flex;
          flex-direction: column;
          align-items: center;

          .name {
            width: 120px;
            height: 26px;
            line-height: 26px;
            background: var(--bg-tag, #F0EDE8);
            border-radius: 4px;
            font-size: 12px;
            font-family: PingFang SC-Medium, PingFang SC;
            font-weight: 500;
            color: var(--text-main, #1A1D24);
            text-align: center;
            margin: 0 0 10px;
          }

          .qr_code {
            margin: 0 0 5px;

            img {
              width: 120px;
              height: 120px;
            }
          }

          .tip {
            display: flex;
            align-items: center;
            font-size: 12px;
            font-family: PingFang SC-Medium, PingFang SC;
            font-weight: 500;
            color: var(--success, #22C55E);
            line-height: 14px;
            margin: 0 0 10px;

            img {
              margin: 0 7px 0 0;
              width: 13.16px;
              height: 12.58px;
            }
          }

        }

        .btn {
          display: block;
          width: 121px;
          height: 30px;
          line-height: 30px;
          text-align: center;
          background: var(--primary, #FF5A1F);
          border-radius: 4px;
          margin: 0 auto 15px;
          color: #FFFFFF;
          box-shadow: 0 6px 12px rgba(26, 29, 36, 0.14);
        }

      }

      .cusSer:hover {
        border-color: var(--primary, #FF5A1F);
        box-shadow: var(--shadow-card, 0 8px 24px rgba(26, 29, 36, 0.08));
        transform: translateY(-2px);
      }

      .QQSGcusSer {
        width: 163px;
        min-height: 170px;

        .cus-head {
          margin: 20px auto 10px;
          width: 30px;
          height: 30px;
        }

        .name {
          padding: 0 10px;
          text-align: center;
          font-size: 14px;
          font-family: PingFang SC-Regular, PingFang SC;
          font-weight: 400;
          color: var(--text-main, #111827);
        }

        .division {
          width: calc(100% - 22px);
          height: 1px;
          margin: 20px auto;
          background-color: var(--border-soft, #E8E4DE);
        }
      }

      .afterWork {
        filter: grayscale(1);
        opacity: 0.72;
        cursor: default;
      }
    }
  }

}
</style>
